import { ChannelIcon } from "@audacia-hq/shared/components";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { Expert } from "../../models/expert";

interface Props {
  expert: Expert;
  onPhoneSelected: () => void;
  onLivechatSelected: () => void;
  onWrittenSelected: () => void;
  onVideoSelected: () => void;
  className?: string;
  faClassName?: string;
  activeType?: string;
  containerClassName?: string;
  containerActiveClassName?: string;
}

const ExpertButtonUI: React.FC<Props> = ({
  expert,
  onPhoneSelected,
  onLivechatSelected,
  onWrittenSelected,
  onVideoSelected,
  className,
  faClassName,
  activeType,
  containerClassName,
  containerActiveClassName,
}) => {
  const getConsultationClass = (enabled: boolean, active?: boolean) => {
    if (enabled && active) return "bg-lime-500";
    return "bg-slate-300";
  };

  const cn = className || "";
  const facn = faClassName || "";

  return (
    <>

      <div className={`${activeType === "PHONE" ? containerActiveClassName : ""} ${containerClassName || ""}`}>
        <button
          type="button"
          aria-label="Phone consultation"
          className="w-full flex place-content-center"
          disabled={!expert.parameters.phoneEnabled || !expert.presenceStatus.phoneStatus}
          onClick={onPhoneSelected}
          data-pw="phone_icon"
        >
          <div
            className={`${getConsultationClass(expert.parameters.phoneEnabled, expert.presenceStatus.phoneStatus)} 
            relative w-10 h-10 rounded-full flex place-content-center ${cn}`}
          >
            <ChannelIcon
              channel="PHONE"
              className={`self-center text-white ${facn}`}
            />
            {expert.parameters.phoneEnabled && expert.presenceStatus.phoneStatus
              && (!expert.presenceStatus.activityStatus || expert.queue?.items.length > 0)
              && (
                <FontAwesomeIcon
                  icon={faPlus}
                  strokeWidth={80}
                  strokeLinecap="round"
                  paintOrder="stroke"
                  className={`absolute top-[15%] right-[15%] stroke-lime-500 text-white ${facn} scale-125`}
                />
              )}
          </div>
        </button>
      </div>

      <div className={`${activeType === "VIDEO" ? containerActiveClassName : ""} ${containerClassName || ""}`}>
        <button
          type="button"
          aria-label="Video consultation"
          className="w-full flex place-content-center"
          disabled={!expert.parameters.videoEnabled || !expert.presenceStatus.videoStatus}
          onClick={onVideoSelected}
          data-pw="video_icon"
        >
          <div
            className={`${getConsultationClass(expert.parameters.videoEnabled, expert.presenceStatus.videoStatus)} 
            relative w-10 h-10 rounded-full flex place-content-center ${cn}`}
          >
            <ChannelIcon
              channel="VIDEO"
              className={`self-center text-white ${facn}`}
            />
            {expert.parameters.videoEnabled && expert.presenceStatus.videoStatus
              && (!expert.presenceStatus.activityStatus || expert.queue?.items.length > 0)
              && (
                <FontAwesomeIcon
                  icon={faPlus}
                  strokeWidth={80}
                  strokeLinecap="round"
                  paintOrder="stroke"
                  className={`absolute top-[15%] right-[15%] stroke-lime-500 text-white ${facn} scale-125`}
                />
              )}
          </div>
        </button>
      </div>

      <div className={`${activeType === "LIVECHAT" ? containerActiveClassName : ""} ${containerClassName || ""}`}>
        <button
          type="button"
          aria-label="Livechat consultation"
          className="w-full flex place-content-center"
          disabled={!expert.parameters.livechatEnabled || !expert.presenceStatus.livechatStatus}
          onClick={onLivechatSelected}
          data-pw="livechat_icon"
        >
          <div
            className={`${getConsultationClass(expert.parameters.livechatEnabled, expert.presenceStatus.livechatStatus)} 
            relative w-10 h-10 rounded-full flex place-content-center ${cn}`}
          >
            <ChannelIcon
              channel="LIVECHAT"
              className={`self-center text-white ${facn}`}
            />
            {expert.parameters.livechatEnabled && expert.presenceStatus.livechatStatus
              && (!expert.presenceStatus.activityStatus || expert.queue?.items.length > 0)
              && (
                <FontAwesomeIcon
                  icon={faPlus}
                  strokeWidth={80}
                  strokeLinecap="round"
                  paintOrder="stroke"
                  className={`absolute top-[15%] right-[15%] stroke-lime-500 text-white ${facn} scale-125`}
                />
              )}
          </div>
        </button>
      </div>

      <div className={`${activeType === "WRITTEN" ? containerActiveClassName : ""} ${containerClassName || ""}`}>
        <button
          type="button"
          aria-label="Written consultation"
          className="w-full flex place-content-center"
          disabled={!expert.parameters.writtenEnabled || !expert.presenceStatus.writtenStatus}
          onClick={onWrittenSelected}
          data-pw="written_icon"
        >
          <div
            className={`${getConsultationClass(expert.parameters.writtenEnabled, expert.presenceStatus.writtenStatus)}
             relative w-10 h-10 rounded-full flex place-content-center ${cn}`}
          >
            <ChannelIcon channel="WRITTEN" className={`self-center text-white ${facn}`} />
            {expert.parameters.writtenEnabled && expert.presenceStatus.writtenStatus && !expert.presenceStatus.activityStatus
              && (
                <FontAwesomeIcon
                  icon={faPlus}
                  strokeWidth={80}
                  strokeLinecap="round"
                  paintOrder="stroke"
                  className={`absolute top-[15%] right-[15%] stroke-lime-500 text-white ${facn} scale-125`}
                />
              )}
          </div>
        </button>
      </div>
    </>
  );
};

export default ExpertButtonUI;
